module.exports = __webpack_public_path__ + "img/josh-hidayat.a33b3178.png";